import { Plugin } from '@ckeditor/ckeditor5-core';
import InsertCalloutCommand from './callout-command';
export default class CalloutEditing extends Plugin {
    init() {
        this.editor.commands.add('insertCallout', new InsertCalloutCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
        this._definePostFixer();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('callout', {
            allowWhere: '$block',
            allowContentOf: '$root',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.elementToElement({
            model: 'callout',
            view: {
                name: 'div',
                classes: 'callout',
            },
        });
    }
    _definePostFixer() {
        const editor = this.editor;
        const schema = editor.model.schema;
        // Postfixer which cleans incorrect model states connected with callouts.
        editor.model.document.registerPostFixer((writer) => {
            const changes = editor.model.document.differ.getChanges();
            for (const entry of changes) {
                if (entry.type == 'insert') {
                    const element = entry.position.nodeAfter;
                    if (!element) {
                        // We are inside a text node.
                        continue;
                    }
                    if (element.is('element', 'callout') && element.isEmpty) {
                        // Added an empty callout - remove it.
                        writer.remove(element);
                        return true;
                    }
                    else if (element.is('element', 'callout') &&
                        !schema.checkChild(entry.position, element)) {
                        // Added a callout in incorrect place - most likely inside another callout. Unwrap it
                        // so the content inside is not lost.
                        writer.unwrap(element);
                        return true;
                    }
                    else if (element.is('element')) {
                        // Just added an element. Check its children to see if there are no nested callouts somewhere inside.
                        const range = writer.createRangeIn(element);
                        for (const child of range.getItems()) {
                            if (child.is('element', 'callout') &&
                                !schema.checkChild(writer.createPositionBefore(child), child)) {
                                writer.unwrap(child);
                                return true;
                            }
                        }
                    }
                }
                else if (entry.type == 'remove') {
                    const parent = entry.position.parent;
                    if (parent.is('element', 'callout') && parent.isEmpty) {
                        // Something got removed and now callout is empty. Remove the callout as well.
                        writer.remove(parent);
                        return true;
                    }
                }
            }
            return false;
        });
    }
}
